import { shippingClient, operatorClient } from 'domain/HttpClients';

export const removeAddress = (id) => {
  try {
    const response = shippingClient
      .Post('/api/address/v2/delete')
      .withParams({ id })
      .send();

    return response;
  } catch (e) {
    console.error(e);
  }
};
export const removeZone = (id) => {
  try {
    const response = operatorClient.Delete(`/api/planning/zoning/zones/${id}`).send();
    return response;
  } catch (e) {
    console.error(e);
  }
};

export const exposeAddressesBasedOnFilters = async (filters, email) => {
  const results = await shippingClient
    .Post('/api/address/expose-as-sheet')
    .withParams({ emails: email })
    .withData(formatExposeFilters(filters))
    .send();
  return results;
};
export const updateZoneState = (id, status, coordinates, description, zoneType) => {
  try {
    const response = operatorClient
      .Put('/api/planning/zoning/zones')
      .withData({
        id,
        status,
        coordinates,
        description,
        zoneType,
      })
      .send();
    return response;
  } catch (e) {
    console.error(e);
  }
};
export const getCititesApi = (val = null) => {
  try {
    const response = shippingClient
      .Get('/api/address/cities')
      .withParams({
        cityName: val,
        countryCode: DEFAULT_COUNTRY.toUpperCase(),
        lang: localStorage.getItem('locale') || 'en',
      })
      .send();

    return response;
  } catch (e) {
    console.error(e);
    return [];
  }
};
export const getCouriers = async (key, accountId = null) => {
  try {
    const response = await operatorClient
      .Get('api/accounts')
      .withParams({ name: key, type: 'COURIER' })
      .send();
    const output = response.results.map((row) => ({
      value: row.key,
      label: row.value.name,
    }));
    return output;
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const getFleets = async (key = null, accountId = null, fleetsId = null) => {
  try {
    const response = await operatorClient
      .Get('/api/fleet/query')
      .withParams({ includeNames: key, includeAccountIds: accountId, includeFleetIds: fleetsId })
      .send();
    const output = response.results.map((row) => ({
      value: row.id,
      label: row.name,
    }));
    return output;
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const fetchAddress = async (code) => {
  try {
    const response = await shippingClient
      .Get('/api/address/v3/search')
      .withParams({ code })
      .send();

    return response.results[0];
  } catch (e) {
    console.error(e);
  }
};

export const saveAddress = async (data) => {
  try {
    const response = await shippingClient
      .Post('/api/address/v2/save')
      .withData(data)
      .send();

    if (response?.error) {
      return false;
    } else {
      return true;
    }
  } catch (e) {
    console.error(e);
    return false;
  }
};

export const getCouriersCompany = async (key = null) => {
  try {
    const response = await operatorClient
      .Get('api/accounts')
      .withParams({ name: key, type: 'PRIMARY_COURIER' })
      .send();
    const output = response.results.map((row) => ({
      value: row.key,
      label: row.value.name,
    }));
    return output;
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const getShippers = async (key = null) => {
  try {
    const response = await operatorClient
      .Get('api/shippers')
      .withParams({ firstName: key, did: `${SYSTEM_DOMAIN}` })
      .send();
    const output = response.results.map((row) => ({
      value: row.id,
      label: row.name,
      subLabel: row.company,
    }));
    return output;
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const getShipperProfile = async (pid) => {
  try {
    const response = await operatorClient.Get(`api/shippers/${pid}`).send();
    const output = [
      {
        value: response.id,
        label: response.name,
        subLabel: response.company,
      },
    ];
    return output;
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const searchAddressByValue = async (value) => {
  try {
    const response = await shippingClient
      .Get('/api/address/v3/search')
      .withParams({ names: value })
      .send();
    const output = response?.results?.map((row) => ({
      value: row.code,
      label: row.name,
    }));
    return output;
  } catch (e) {
    console.error(e);
    return [];
  }
};

export const upload = async (fileName) => {
  const results = await shippingClient
    .Post('/api/address/upload-batch')
    .withData(fileName)
    .send();
  return results;
};

export const uploadSheet = async (formData) => {
  const results = shippingClient
    .Post(UPLOAD_URL)
    .withData(formData)
    .send();
  return results;
};
